import { useContext, useEffect, useRef, useState } from "react";
import { SearchDuotoneIcon, SearchCloseDuotoneIcon } from "../../svg";
import CloseIcon from "@mui/icons-material/Close";
import { logger } from "../../../helper/logger";
import { useDebounce } from "../../../hooks/useDebounce";
import MapIsTypingContext from "context/MapIsTypingContext";

export default function SearchBar({
  placeholder = "Search shipments",
  onChange,
  value
}) {

  const { setIsInputFocused } = useContext(MapIsTypingContext);
  const [isOpen, setIsOpen] = useState(value ? true : false);
  const [text, setText] = useState(value || "");
  const debouncedSearchTerm = useDebounce(text, 500);
  const handleClose = () => {
    setText("");
    onChange("");
    setIsOpen(false);
  };

  const inputRef = useRef(null)
  const handleOpen = () => {
    setIsOpen(true);
  };

  const onFocus = () => {
    setIsInputFocused(true)
  }

  const onBlur = () => {
    setIsInputFocused(false)
  }

  useEffect(() => {
    if (isOpen)
      inputRef.current.focus()
  }, [isOpen])

  useEffect(() => {
    onChange(debouncedSearchTerm);

  }, [debouncedSearchTerm]);

  return (
    <>
      {!isOpen ? (
        <span
          className={`px-2 pt-1 `}
          onClick={handleOpen}>
          <SearchDuotoneIcon />
        </span>
      ) : (<div className="text-[#666] px-2 pt-1" onClick={handleClose}><SearchCloseDuotoneIcon /></div>)}
      <div className={`rounded-md flex items-center justify-between bg-gray-100 ${isOpen ? "w-[220px] h-full absolute left-0 z-10 py-1 mt-[7px]" : "w-0"} `}>
        <div
          className={`bg-[#ffffff] flex items-center ${isOpen
            ? "w-full max-w-[400px] p-1 bg-white shadow-md"
            : " bg-transparent"
            } bg-white rounded-md text-sm mr-1`}>
          <input
            onFocus={onFocus}
            onBlur={onBlur}
            ref={inputRef}
            className={`${isOpen ? "flex" : "hidden"
              }  rounded-lg py-[5px] ml-2 flex-1 ouline-none bg-white focus:outline-none`}
            placeholder={placeholder}
            onChange={(e) => setText(e?.target?.value)}
            value={text} />
          {isOpen && (
            <span
              className={`pl-3 pr-1 hover:cursor-pointer`}
              onClick={() => {
                logger("searching");
              }}>
              <SearchDuotoneIcon color="#666" width={18} height={18} />
            </span>
          )}
        </div>
      </div>
    </>
  );
}
